// extracted by mini-css-extract-plugin
export default {"iconContainer":"Icon_iconContainer__XRpFK"};